import React from 'react';
import { Box, useTheme } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

const Loading = () => {
  const theme = useTheme();

  return (
    <Box display="flex" px={3} height={theme.spacing(9)} alignItems="center">
      <Box>
        <Skeleton variant="circle" width={50} height={50} />
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        flexGrow={1}
        pl={1}
        maxWidth={300}
      >
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="30%" />
      </Box>
    </Box>
  );
};

export default Loading;
